"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ChatIcon = require("./ChatIcon");
Object.keys(_ChatIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatIcon[key];
    }
  });
});